var styleDataHash = "86397c1f";
const injectCss = (() => {
  var css = `.aUGMr{align-items:center;background-color:#fff;box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;font-size:14px;height:40px;padding-left:20px;padding-right:20px;width:100%}.aUGMr *,.aUGMr :after,.aUGMr :before{box-sizing:inherit}.aUGMr input{box-sizing:border-box}.aUGMr>*{flex:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var list_item_toggle_default = {
  "container": "aUGMr"
};
export {
  list_item_toggle_default as default,
  injectCss
};
//# sourceMappingURL=list-item-toggle-scss.js.map
